export default __webpack_public_path__ + "static/media/onHand.afaa21f6.svg";